import { createPlugins, withPlate, createPluginFactory } from '@udecode/plate';
import { Editor, createEditor } from 'slate';
import _ from 'lodash';

import deserializeHtml from 'components/text_editor_new/lib/deserialize_html';

// Dependencies: VariablesPlugin created using useCreateVariablesPlugin hook
export function createAnswersPlugin() {
  return createPluginFactory({
    key: 'answers',
    withOverrides: withAnswersCommands,
  })();
}

function withAnswersCommands(editor) {
  editor.getSaturatedFragment = html => {
    const fragmentHtml = _.trim(html) || '<div></div>';

    // We do this by creating an entirely separate editor controller and updating the variables in it first,
    // then just returning the children as if nothing ever happened ;)
    const fragmentEditor = createFragmentEditor(editor);
    fragmentEditor.children = deserializeHtml(fragmentHtml, fragmentEditor);
    Editor.normalize(fragmentEditor, { force: true });

    fragmentEditor.updateVariables();
    return fragmentEditor.children;
  };

  return editor;
}

function createFragmentEditor(editor) {
  const plugins = createPlugins(editor.plugins);
  return withPlate(createEditor(), { plugins });
}
